// import React, { useState, useMemo } from "react";
// import "./SavingReport.css";

// const sampleData = [
//   {
//     accountNo: "1234567890",
//     status: "Active",
//     name: "Navin Kumar",
//     guardian: "Ramesh Kumar",
//     mobile: "9876543210",
//     aadhaar: "1234-5678-9012",
//     approvalDate: "2023-01-01",
//     lastTransaction: "2023-08-01",
//     approvedBy: "Manager A",
//     balance: 40000,
//     accountType: "Savings",
//     branch: "XYZ Branch",
//     email: "navin@example.com",
//     nominee: "Rita Kumari",
//   },
//   {
//     accountNo: "0987654321",
//     status: "Pre-Closed",
//     name: "Anita Sharma",
//     guardian: "Suresh Sharma",
//     mobile: "9123456780",
//     aadhaar: "5678-1234-9012",
//     approvalDate: "2022-06-15",
//     lastTransaction: "2023-02-01",
//     approvedBy: "Manager B",
//     balance: 0,
//     accountType: "Salary",
//     branch: "ABC Branch",
//     email: "anita@example.com",
//     nominee: "Sunita Sharma",
//   },
//    {
//     accountNo: "0895654321",
//     status: "Closed",
//     name: "Monika Sharma",
//     guardian: "Naresh Sharma",
//     mobile: "7223456780",
//     aadhaar: "4567-1234-9012",
//     approvalDate: "2024-06-15",
//     lastTransaction: "2024-12-01",
//     approvedBy: "Manager A",
//     balance: 0,
//     accountType: "Salary",
//     branch: "ABC Branch",
//     email: "anita@example.com",
//     nominee: "Mina Sharma",
//   },
//   {
//     accountNo: "8271943212",
//     status: "Reject",
//     name: "Mahesh Sharma",
//     guardian: "K.K Sharma",
//     mobile: "7250437802",
//     aadhaar: "9312-1234-9012",
//     approvalDate: "2025-06-15",
//     lastTransaction: "2025-12-01",
//     approvedBy: "Manager A",
//     balance: 0,
//     accountType: "Salary",
//     branch: "ABCD Branch",
//     email: "K.K@example.com",
//     nominee: "K.K Sharma",
//   },
// ];

// const SavingReport = () => {
//   const [search, setSearch] = useState("");
//   const [accountType, setAccountType] = useState("");
//   const [status, setStatus] = useState("");
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [entriesPerPage, setEntriesPerPage] = useState(10);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
//   const [filtersApplied, setFiltersApplied] = useState(false);

//   // Filtered Data
//   const filteredData = useMemo(() => {
//     if (!filtersApplied) return sampleData;
//     return sampleData.filter((acc) => {
//       const matchSearch =
//         acc.name.toLowerCase().includes(search.toLowerCase()) ||
//         acc.accountNo.includes(search) ||
//         acc.mobile.includes(search);

//       const matchType = accountType ? acc.accountType === accountType : true;
//       const matchStatus = status ? acc.status === status : true;
//       const matchFromDate = fromDate ? new Date(acc.approvalDate) >= new Date(fromDate) : true;
//       const matchToDate = toDate ? new Date(acc.approvalDate) <= new Date(toDate) : true;

//       return matchSearch && matchType && matchStatus && matchFromDate && matchToDate;
//     });
//   }, [search, accountType, status, fromDate, toDate, filtersApplied]);

//   // Sorting
//   const sortedData = useMemo(() => {
//     if (!sortConfig.key) return filteredData;
//     const sorted = [...filteredData].sort((a, b) => {
//       let valA = a[sortConfig.key];
//       let valB = b[sortConfig.key];
//       if (typeof valA === "string") valA = valA.toLowerCase();
//       if (typeof valB === "string") valB = valB.toLowerCase();
//       if (valA < valB) return sortConfig.direction === "ascending" ? -1 : 1;
//       if (valA > valB) return sortConfig.direction === "ascending" ? 1 : -1;
//       return 0;
//     });
//     return sorted;
//   }, [filteredData, sortConfig]);

//   const totalPages = Math.ceil(sortedData.length / entriesPerPage);
//   const paginatedData = sortedData.slice(
//     (currentPage - 1) * entriesPerPage,
//     currentPage * entriesPerPage
//   );

//   const summary = {
//     totalAccounts: filteredData.length,
//     activeAccounts: filteredData.filter((a) => a.status === "Active").length,
//     totalBalance: filteredData.reduce((sum, a) => sum + a.balance, 0),
//   };

//   const requestSort = (key) => {
//     let direction = "ascending";
//     if (sortConfig.key === key && sortConfig.direction === "ascending") direction = "descending";
//     setSortConfig({ key, direction });
//   };

//   const highlightSearch = (text) => {
//     if (!search) return text;
//     const regex = new RegExp(`(${search})`, "gi");
//     return text.split(regex).map((part, i) =>
//       regex.test(part) ? <span key={i} className="saving-reporthighlight">{part}</span> : part
//     );
//   };

//   const startEntry = (currentPage - 1) * entriesPerPage + 1;
//   const endEntry = Math.min(currentPage * entriesPerPage, filteredData.length);

//   return (
//     <div className="saving-report-container">
//       <h2>Saving Account Filter</h2>

//       {/* Filters Section */}
  

    

//       {/* Entries per page */}
//       <h3 className="saving-reporth3">Saving Account Report</h3>
//       <div className="saving-reportentries-per-page">
        
//         Show
//         <select
//           value={entriesPerPage}
//           onChange={(e) => {
//             setEntriesPerPage(Number(e.target.value));
//             setCurrentPage(1);
//           }}
//         >
//           <option value={5}>5</option>
//           <option value={10}>10</option>
//           <option value={25}>25</option>
//           <option value={50}>50</option>
//         </select>
//         entries
//       </div>

//       {/* Table */}
//       <div className="saving-reporttable-container">
//         <table className="saving-reportsaving-table">
//           <thead>
//             <tr>
//               {[
//                 { label: "SN", key: null },
//                 { label: "Account No", key: "accountNo" },
//                 { label: "Status", key: "status" },
//                 { label: "Name", key: "name" },
//                 { label: "Guardian", key: "guardian" },
//                 { label: "Mobile", key: "mobile" },
//                 { label: "Aadhar", key: "aadhaar" },
//                 { label: "Approval Date", key: "approvalDate" },
//                 { label: "Last Transaction", key: "lastTransaction" },
//                 { label: "Approved By", key: "approvedBy" },
//                 { label: "Balance", key: "balance" },
//                 { label: "Email", key: "email" },
//                 { label: "Nominee", key: "nominee" },
//               ].map((col) => (
//                 <th
//                   key={col.label}
//                   onClick={() => col.key && requestSort(col.key)}
//                   className={col.key ? "sortable" : ""}
//                 >
//                   {col.label}
//                   {sortConfig.key === col.key
//                     ? sortConfig.direction === "ascending"
//                       ? " ▲"
//                       : " ▼"
//                     : ""}
//                 </th>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedData.length ? (
//               paginatedData.map((acc, index) => (
//                 <tr
//                   key={acc.accountNo}
//                   className={
//                     acc.status === "Pre-Closed"
//                       ? "preclosed-row"
//                       : acc.status === "Closed"
//                       ? "closed-row"
                     
//                       : acc.status === "Active"
//                       ? "active-row"
                         
//                        : acc.status === "Reject"
//                       ? "reject-row"

//                        : ""
//                   }
//                 >
//                   <td data-label="SN">{(currentPage - 1) * entriesPerPage + index + 1}</td>
//                   <td data-label="Account No">{highlightSearch(acc.accountNo)}</td>
//                   <td data-label="Status">
//                     <span
//                       className={`status-badge ${
//                         acc.status === "Active"
//                           ? "status-active"
//                           : acc.status === "Closed"
//                           ? "status-closed"
//                           : acc.status === "Pre-Closed"
//                           ? "status-preclosed"
//                           : acc.status === "Reject"
//                           ? "status-reject"
//                           : "status-other"
//                       }`}
//                     >
//                       {highlightSearch(acc.status)}
//                     </span>
//                   </td>
//                   <td data-label="Name">{highlightSearch(acc.name)}</td>
//                   <td data-label="Guardian">{highlightSearch(acc.guardian)}</td>
//                   <td data-label="Mobile">{highlightSearch(acc.mobile)}</td>
//                   <td data-label="Aadhar">{highlightSearch(acc.aadhaar)}</td>
//                   <td data-label="Approval Date">{acc.approvalDate}</td>
//                   <td data-label="Last Transaction">{acc.lastTransaction}</td>
//                   <td data-label="Approved By">{highlightSearch(acc.approvedBy)}</td>
//                   <td data-label="Balance" className={`balance-cell ${
//                     acc.balance === 0 ? "balance-zero" : acc.balance < 1000 ? "balance-low" : "balance-ok"
//                   }`}>
//                     ₹{acc.balance.toLocaleString()}
//                   </td>
//                   <td data-label="Email">{highlightSearch(acc.email)}</td>
//                   <td data-label="Nominee">{highlightSearch(acc.nominee)}</td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan={13} style={{ textAlign: "center", padding: "20px" }}>
//                   No entries found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
// <div className="saving-reportpagination">
//   <span className="saving-reportpagination-info">
//     Showing {filteredData.length ? (currentPage - 1) * entriesPerPage + 1 : 0} to{" "}
//     {currentPage * entriesPerPage > filteredData.length
//       ? filteredData.length
//       : currentPage * entriesPerPage}{" "}
//     of {filteredData.length} entries
//   </span>

//   <button
//     onClick={() => setCurrentPage((prev) => prev - 1)}
//     disabled={currentPage === 1}
//     className="pagination-btn"
//   >
//     Previous
//   </button>

//   <button
//     onClick={() => setCurrentPage((prev) => prev + 1)}
//     disabled={currentPage === totalPages || totalPages === 0}
//     className="pagination-btn"
//   >
//     Next
//   </button>
// </div>

//     </div>
//   );
// };



// export default SavingReport;
import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import "./SavingReport.css";

const SavingReport = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [accountType, setAccountType] = useState("");
  const [status, setStatus] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [loading, setLoading] = useState(false);

  // ✅ Fetch Data from API
  const fetchSavingAccounts = async () => {
    try {
      setLoading(true);
      const superAdminId = localStorage.getItem("superAdminId") || 14;
      const branchId = localStorage.getItem("branchId") || 8;
      console.log("branchid ",branchId);
      const res = await axios.get("https://payyug.in/api/get-all-saving-account", {
        params: { superAdminId, branchId },
      });

      console.log("🔵 Saving Accounts API Response:", res.data);

      if (res.data.success && Array.isArray(res.data.data)) {
        setData(res.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Error fetching saving accounts:", err);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchSavingAccounts();
  }, []);

  // ✅ Filtered Data
  const filteredData = useMemo(() => {
    if (!filtersApplied) return data;

    return data.filter((acc) => {
      const matchSearch =
        acc.customerName?.toLowerCase().includes(search.toLowerCase()) ||
        acc.accountNumber?.includes(search) ||
        acc.mobileNumber?.includes(search);

      const matchType = accountType ? acc.accountType === accountType : true;
      const matchStatus = status ? acc.status === status : true;
      const matchFromDate = fromDate ? new Date(acc.openedDate) >= new Date(fromDate) : true;
      const matchToDate = toDate ? new Date(acc.openedDate) <= new Date(toDate) : true;

      return matchSearch && matchType && matchStatus && matchFromDate && matchToDate;
    });
  }, [data, search, accountType, status, fromDate, toDate, filtersApplied]);

  // ✅ Sorting
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return filteredData;
    const sorted = [...filteredData].sort((a, b) => {
      let valA = a[sortConfig.key];
      let valB = b[sortConfig.key];
      if (typeof valA === "string") valA = valA.toLowerCase();
      if (typeof valB === "string") valB = valB.toLowerCase();
      if (valA < valB) return sortConfig.direction === "ascending" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "ascending" ? 1 : -1;
      return 0;
    });
    return sorted;
  }, [filteredData, sortConfig]);

  // ✅ Pagination
  const totalPages = Math.ceil(sortedData.length / entriesPerPage);
  const paginatedData = sortedData.slice(
    (currentPage - 1) * entriesPerPage,
    currentPage * entriesPerPage
  );

  const summary = {
    totalAccounts: filteredData.length,
    activeAccounts: filteredData.filter((a) => a.status === "Active").length,
    totalBalance: filteredData.reduce((sum, a) => sum + (a.currentBalance || 0), 0),
  };

  const requestSort = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") direction = "descending";
    setSortConfig({ key, direction });
  };

  const highlightSearch = (text) => {
    if (!search || !text) return text;
    const regex = new RegExp(`(${search})`, "gi");
    return text.split(regex).map((part, i) =>
      regex.test(part) ? <span key={i} className="saving-reporthighlight">{part}</span> : part
    );
  };

  return (
    <div className="saving-report-container">
      <h2>Saving Account Report</h2>

      {/* Filters */}
      <div className="saving-reportfilters">
        <input
          type="text"
          placeholder="Search by Name / Account No / Mobile"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />

        <select value={accountType} onChange={(e) => setAccountType(e.target.value)}>
          <option value="">All Account Types</option>
          <option value="Saving">Saving</option>
          <option value="Current">Current</option>
        </select>

        <select value={status} onChange={(e) => setStatus(e.target.value)}>
          <option value="">All Status</option>
          <option value="Active">Active</option>
          <option value="Closed">Closed</option>
          <option value="Pre-Closed">Pre-Closed</option>
          <option value="Reject">Reject</option>
        </select>

        <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
        <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} />

        <button
          className="filter-btn"
          onClick={() => {
            setFiltersApplied(true);
            setCurrentPage(1);
          }}
        >
          Apply
        </button>
        <button
          className="reset-btn"
          onClick={() => {
            setSearch("");
            setAccountType("");
            setStatus("");
            setFromDate("");
            setToDate("");
            setFiltersApplied(false);
          }}
        >
          Reset
        </button>
      </div>

      {/* Summary */}
      <div className="saving-reportsummary">
        <p>Total Accounts: <b>{summary.totalAccounts}</b></p>
        <p>Active Accounts: <b>{summary.activeAccounts}</b></p>
        <p>Total Balance: <b>₹{summary.totalBalance.toLocaleString()}</b></p>
      </div>

      {/* Entries per page */}
      <div className="saving-reportentries-per-page">
        Show
        <select
          value={entriesPerPage}
          onChange={(e) => {
            setEntriesPerPage(Number(e.target.value));
            setCurrentPage(1);
          }}
        >
          <option value={5}>5</option>
          <option value={10}>10</option>
          <option value={25}>25</option>
          <option value={50}>50</option>
        </select>
        entries
      </div>

      {/* Table */}
      <div className="saving-reporttable-container">
        {loading ? (
          <p style={{ textAlign: "center", padding: "20px" }}>Loading...</p>
        ) : (
          <table className="saving-reportsaving-table">
            <thead>
              <tr>
                {[
                  { label: "SN", key: null },
                  { label: "Account No", key: "accountNumber" },
                  { label: "Status", key: "status" },
                  { label: "Customer Name", key: "customerName" },
                  { label: "Mobile", key: "mobileNumber" },
                  { label: "Account Type", key: "accountType" },
                  { label: "Branch", key: "branchName" },
                  { label: "Opening Balance", key: "openingBalance" },
                  { label: "Current Balance", key: "currentBalance" },
                  { label: "Opened Date", key: "openedDate" },
                  { label: "Approved By", key: "approvedBy" },
                ].map((col) => (
                  <th
                    key={col.label}
                    onClick={() => col.key && requestSort(col.key)}
                    className={col.key ? "sortable" : ""}
                  >
                    {col.label}
                    {sortConfig.key === col.key
                      ? sortConfig.direction === "ascending"
                        ? " ▲"
                        : " ▼"
                      : ""}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {paginatedData.length ? (
                paginatedData.map((acc, index) => (
                  <tr
                    key={acc.id}
                    className={
                      acc.status === "Pre-Closed"
                        ? "preclosed-row"
                        : acc.status === "Closed"
                        ? "closed-row"
                        : acc.status === "Active"
                        ? "active-row"
                        : acc.status === "Reject"
                        ? "reject-row"
                        : ""
                    }
                  >
                    <td>{(currentPage - 1) * entriesPerPage + index + 1}</td>
                    <td>{highlightSearch(acc.accountNumber)}</td>
                    <td>{highlightSearch(acc.status)}</td>
                    <td>{highlightSearch(acc.customerName)}</td>
                    <td>{highlightSearch(acc.mobileNumber)}</td>
                    <td>{acc.accountType}</td>
                    <td>{acc.branchName}</td>
                    <td>₹{acc.openingBalance?.toLocaleString()}</td>
                    <td>₹{acc.currentBalance?.toLocaleString()}</td>
                    <td>{acc.openedDate?.split("T")[0]}</td>
                    <td>{acc.approvedBy || "-"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={12} style={{ textAlign: "center", padding: "20px" }}>
                    No entries found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        )}
      </div>

      {/* Pagination */}
      <div className="saving-reportpagination">
        <span className="saving-reportpagination-info">
          Showing {filteredData.length ? (currentPage - 1) * entriesPerPage + 1 : 0} to{" "}
          {currentPage * entriesPerPage > filteredData.length
            ? filteredData.length
            : currentPage * entriesPerPage}{" "}
          of {filteredData.length} entries
        </span>

        <button
          onClick={() => setCurrentPage((prev) => prev - 1)}
          disabled={currentPage === 1}
          className="pagination-btn"
        >
          Previous
        </button>

        <button
          onClick={() => setCurrentPage((prev) => prev + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          className="pagination-btn"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default SavingReport;
